// @flow

const baseColors = {
  // Blues
  blue: 'rgba(1, 116, 224, 1)',
  focusedBlue: '#0174E0',
  darkblue: '#0060BF',
  lightblue: '#A1CFF8',
  lighterblue: '#EBF6FF',
  blue08: 'rgba(1, 116, 224, 0.08)',
  // Greens
  green: '#1FAE96',
  darkgreen: '#167B6A',
  lightgreen: '#A5DED5',
  lightergreen: '#E9F7F4',
  // Reds
  red: '#E14E38',
  darkred: '#B43E2C',
  lightred: '#F3B8AF',
  lighterred: '#FCEDEB',
  // Yellows
  yellow: '#F5AF22',
  darkyellow: '#C78E1C',
  lightyellow: '#FBDFA6',
  lighteryellow: '#FFF8EB',
  highlight: '#FFF8D6',
  // Gradients
  gradient: 'linear-gradient(-45deg, #3FA8B0 0%, #1FAE96 100%)',
  // Grays
  darkestgray: '#222D38',
  darkergray: '#617080',
  darkgray: '#92A0AD',
  gray: '#C5CED6',
  lightgray: '#DCE1E6',
  lightergray: '#F0F2F5',
  lightestgray: '#F7F9FA',
  faint: '#FAFBFC',
  // Borders
  border: '#DCE1E6',
  // Whites
  white: '#FFFFFF',
  white72: 'rgba(255, 255, 255, 0.72)',
  white52: 'rgba(255, 255, 255, 0.52)',
  white32: 'rgba(255, 255, 255, 0.32)',
  white16: 'rgba(255, 255, 255, 0.16)',
  white08: 'rgba(255, 255, 255, 0.08)',
};

const extraColors = {
  good: baseColors.green,
  warn: baseColors.yellow,
  bad: baseColors.red,
  notice: baseColors.blue,
  grayblue: '#75828f',
  buttonPrimary: baseColors.blue,
  buttonPrimaryHover: baseColors.darkblue,
  buttonDestructive: baseColors.red,
  buttonDestructiveHover: baseColors.darkred,
};

// https://github.com/latticehr/lattice/commit/f4cafc7a72f222aed9ab9187eca3ef09404af10f
module.exports = Object.assign({}, baseColors, extraColors);
